import styled from 'styled-components';

export const LogoContainer = styled.a`
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const StyledLogo = styled.img`
    width: 50px;
    height: 50px;
    filter: invert(100%);
`;

export const StyledLink = styled.p`
    color: white;
    font-family: Roboto Condensed;
    margin-left: 7px;
    font-size: 14px;
    font-weight: 400;
`;
